import IdleJs from "idle-js";

type IdleSubscriber = () => void | Promise<void>;

/*
 * The client activity monitoring manager:
 * If the client puts the computer to sleep or hibernation and then returns,
 * we need the store to automatically update all its states,
 * as the client was absent for an unknown period and changes might have occurred in the show data.
 * */
export class IdleManager {
  private static instance: IdleManager;

  private idle: IdleJs;

  private subscribers: Map<string, IdleSubscriber> = new Map();

  private constructor() {
    this.idle = new IdleJs({
      idle: 60_000,
      onActive: async () => {
        this.subscribers.forEach((subscriber: IdleSubscriber) => {
          subscriber();
        });
      },
    });
    this.idle.start();
  }

  public static getInstance(): IdleManager {
    if (!IdleManager.instance) {
      IdleManager.instance = new IdleManager();
    }
    return IdleManager.instance;
  }

  public addSubscriber(key: string, callback: IdleSubscriber): void {
    if (!this.subscribers.has(key)) {
      this.subscribers.set(key, callback);
    }
  }

  public removeSubscriber(key: string): void {
    this.subscribers.delete(key);
  }
}
